const convertModelToQueryString = model => {
  return Object.keys(model)
    .map(key => key + '=' + encodeURIComponent(model[key]))
    .join('&');
};

export default convertModelToQueryString;
